export const sortPools = (pools) => {
  const currentTimestamp = Date.now() / 1000;
  return pools.sort((presale1, presale2) => {
    if (
      Number(presale1.openTime) > currentTimestamp &&
      Number(presale2.openTime) > currentTimestamp
    ) {
      return Number(presale1?.openTime) - Number(presale2?.openTime);
    }
    if (
      Number(presale1.openTime) < currentTimestamp &&
      Number(presale2.openTime) < currentTimestamp
    ) {
      return Number(presale1?.openTime) - Number(presale2?.openTime);
    }
    if (
      Number(presale1.openTime) > currentTimestamp &&
      Number(presale2.openTime) < currentTimestamp
    ) {
      return -1;
    }
    if (
      Number(presale1.openTime) < currentTimestamp &&
      Number(presale2.openTime) > currentTimestamp
    ) {
      return 1;
    }
    return 1;
  });
};
